<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="mb-2"
          >
            <v-select
              id="id_projects"
              v-model="filterData.id_projects"
              :options="projects"
              label="title"
              :reduce="item => item.id"
              placeholder="Proje seçin."
              @input="getLicenses"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-2"
          >
            <v-select
              id="id_licenses"
              v-model="filterData.id_licenses"
              :options="licenses"
              label="title"
              :reduce="item => item.id"
              placeholder="Müşteri seçin."
              :disabled="!this.filterData.id_projects"
            >
              <template v-slot:option="option">
                {{ option.title }}
                <div v-if="option.project_package">
                  <small class="text-warning">{{ option.project_package }}</small>
                </div>
              </template>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-2"
          >
            <b-input-group>
              <b-form-datepicker
                v-model="filterData.sdate"
                v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
              />
              <b-input-group-append v-if="filterData.sdate">
                <b-button
                  variant="warning"
                  @click="clearDate('sdate')"
                >
                  <FeatherIcon icon="XIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-2"
          >
            <b-input-group>
              <b-form-datepicker
                v-model="filterData.edate"
                v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
              />
              <b-input-group-append v-if="filterData.edate">
                <b-button
                  variant="warning"
                  @click="clearDate('edate')"
                >
                  <FeatherIcon icon="XIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="text-center"
          >
            <b-button
              variant="primary"
              :disabled="dataLoading"
              @click="dataFilter"
            >
              <feather-icon
                v-if="!dataLoading"
                icon="FilterIcon"
              />
              <b-spinner
                v-else
                small
              />
              Listele
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
          small
        >
          <template #cell(username)="data">
            {{ data.item.username }}
            <div v-if="data.item.project">
              <small class="text-primary">{{ data.item.project }}</small>
            </div>
          </template>
          <template #cell(action)="data">
            <b-badge
              v-if="data.item.action === 'modified'"
              variant="light-warning"
            >
              <feather-icon icon="EditIcon" />
              Düzenleme
            </b-badge>
            <b-badge
              v-if="data.item.action === 'deleted'"
              variant="light-danger"
            >
              <feather-icon icon="TrashIcon" />
              Silme
            </b-badge>
            <b-badge
              v-if="data.item.action === 'created'"
              variant="light-primary"
            >
              <feather-icon icon="PlusIcon" />
              Oluşturma
            </b-badge>
            <div>
              <small class="text-muted">{{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}</small>
            </div>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <b-button
                variant="outline-primary"
                size="sm"
                :to="$route.path + '/view/' + data.item.id"
              >
                Görüntüle
              </b-button>
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <template v-else-if="dataLoading">
        <pre-loading
          class="m-2"
        />
      </template>
      <b-alert
        v-else
        show
        variant="info"
        class="m-2"
      >
        <div class="alert-body text-center">
          <FeatherIcon icon="InfoIcon" />
          <div>
            <b>Kayıtlı veri bulunamadı.</b>
          </div>
          <div>
            <small>
              Proje seçerek aktivite kayıtlarına ulaşabilirsiniz.
            </small>
          </div>
        </div>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCol, BRow, BCardBody, BCardFooter, BPagination, BTable, BButton, BAlert, BBadge, BFormDatepicker, BSpinner, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

const tableName = 'event_logs'

export default {
  name: 'Index',
  components: {
    PreLoading,
    vSelect,
    BFormDatepicker,
    BAlert,
    BCard,
    BCol,
    BRow,
    BCardBody,
    BCardFooter,
    BPagination,
    BTable,
    BButton,
    BBadge,
    BSpinner,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'username',
          label: 'Gerçekleştiren',
        },
        { key: 'ip_address', label: 'İp Adres' },
        {
          key: 'component',
          label: 'Modül',
          thStyle: { width: '180px' },
        },
        {
          key: 'action',
          label: 'İşlem',
          thStyle: { width: '130px' },

        },

        {
          key: 'control',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.data AS data`,
          `${tableName}.component AS component`,
          `${tableName}.action AS action`,
          `${tableName}.ip_address AS ip_address`,
          `${tableName}.id_licenses AS id_licenses`,
          `${tableName}.created AS created`,
          'users.name AS username',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projectEventLogs/dataList']
    },
    filterData() {
      return this.$store.getters['projectEventLogs/filterData']
    },
    dataCounts() {
      return this.$store.getters['projectEventLogs/dataCounts']
    },
    projects() {
      return this.$store.getters['projects/dataList']
    },
    licenses() {
      return this.$store.getters['licenses/dataList']
    },
    dataLoading() {
      return this.$store.getters['projectEventLogs/getDataLoading']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getProjects()
  },
  methods: {
    clearDate(val) {
      if (val === 'sdate') {
        this.filterData.sdate = null
      }
      if (val === 'edate') {
        this.filterData.edate = null
      }
    },
    resetFilter() {
      this.$store.commit('projectEventLogs/RESET_FILTER_DATA')
      this.$store.commit('projectEventLogs/RESET_DATA_LIST')
    },
    dataFilter() {
      const where = {}
      if (this.filterData.sdate) {
        where['date(event_logs.created) >='] = this.filterData.sdate
      }
      if (this.filterData.edate) {
        where['date(event_logs.created) <='] = this.filterData.edate
      }
      if (this.filterData.id_projects) {
        this.dataQuery.id_projects = this.filterData.id_projects
      }
      if (this.filterData.id_licenses) {
        where['event_logs.id_licenses'] = this.filterData.id_licenses
      }
      this.dataQuery.where = where
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('projectEventLogs/getDataList', this.dataQuery)
    },
    getProjects() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title',
        ],
        where: {
          'projects.status': 1,
        },
      })
    },
    getLicenses() {
      this.filterData.id_licenses = null
      if (this.filterData.id_projects) {
        this.$store.dispatch('licenses/getDataList', {
          select: [
            'licenses.id AS id',
            'customers.company AS title',
            'project_packages.title AS project_package',
          ],
          where: {
            'licenses.id_projects': this.filterData.id_projects,
            'licenses.status': 1,
          },
        })
      }
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projectEventLogs/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
